/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Custom user roles check
 *
 * @author Nikolay Sviridov
 * @version 1.31.0
 * @since 1.31.0
 */

import { useMemo } from 'react';

import find from 'lodash/find';
import { useSelector } from 'react-redux';

import { AuthorityRoleEnum } from '@pages/PageAuth/constants/authConstants';
import { makeSelectAuthoritiesIsCustomUser, makeSelectAuthoritiesRoles } from '@pages/PageAuth/selectors/authSelectors';


export const useCheckCustomRole = (returnBooleanIfNoCustomUserRole: boolean, role: AuthorityRoleEnum) => {

    const isCustomUser = useSelector(makeSelectAuthoritiesIsCustomUser());
    const authorities = useSelector(makeSelectAuthoritiesRoles());

    return useMemo(() => {
        //если это не кастомный пользователь, то проверка кастомной роли не требуется
        if (!isCustomUser) {
            /*
            Если результат данного хука используется в логическом ИЛИ, то при отсутствии роли
            ROLE_CUSTOM_USER нужно вернуть false, чтобы не сломать логику отображения компонента.
            */
            /*
            Если результат используется в логическом И, то надо вернуть true.
            */

            return returnBooleanIfNoCustomUserRole;
        }
        return !!find(authorities, (authority) => authority === role);
    },[authorities, returnBooleanIfNoCustomUserRole, isCustomUser, role])

};
